import { render, staticRenderFns } from "./Impact.vue?vue&type=template&id=75b3bcd3"
import script from "./Impact.vue?vue&type=script&lang=js"
export * from "./Impact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports